import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AlertService, AuthService, UIService } from './../_services/index';
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService,
    private uiservice : UIService) { }

  ngOnInit() {
    this.uiservice.setTitle('Logout');
    // go to the login page once the API has revoked the refresh token, or failed to
    this.authenticationService.logout()
      .pipe(finalize(() => this.router.navigate(['/login'])))
      .subscribe({ error: () => {} });
  }
}
